import centroid from '@turf/centroid'
import bboxPolygon from "@turf/bbox-polygon";
import {feature} from '@turf/helpers'

function getCenter(boundingBox) {
    const polygon = bboxPolygon(boundingBox)
    const centerFeature = centroid(polygon)
    const [longitude, latitude] = centerFeature.geometry.coordinates

    return  { longitude, latitude }
}

export function polygonCenter(geometry){
       const poly = feature(geometry)
    const centerFeature = centroid(poly)
    const [longitude, latitude] = centerFeature.geometry.coordinates

    return  { longitude, latitude }
}

export default getCenter



// WEBPACK FOOTER //
// ./src/utils/getCenter.js